import { render, staticRenderFns } from "./Announce.vue?vue&type=template&id=65a8f47a&scoped=true&"
import script from "./Announce.vue?vue&type=script&lang=ts&"
export * from "./Announce.vue?vue&type=script&lang=ts&"
import style0 from "./Announce.vue?vue&type=style&index=0&id=65a8f47a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a8f47a",
  null
  
)

export default component.exports